import { z } from 'zod';

export const templateGenerationRequestSchema = z.object({
  templateCode: z.string(),
  templateMetadata: z.object({
    title: z.string(),
    description: z.string(),
    variables: z.array(z.string()),
    exampleValues: z.record(z.string()),
  }),
  userPrompt: z.string().optional(),
  language: z.string().default('es'),
});

export const aiGeneratedTemplateSchema = z.object({
  message: z.string().describe('Mensaje generado con variables en formato {{variable}}'),
  tone: z.enum(['professional', 'friendly', 'casual', 'urgent']).describe('Tono del mensaje'),
  usedVariables: z.array(z.string()).describe('Variables utilizadas en el mensaje'),
  suggestions: z.array(z.string()).optional().describe('Sugerencias adicionales'),
});

export type TemplateGenerationRequest = z.infer<typeof templateGenerationRequestSchema>;
export type AIGeneratedTemplate = z.infer<typeof aiGeneratedTemplateSchema>;
